import React from 'react'

function TargetHeader() {
  return (
    <div className="item__header target">
      <h3>target</h3>
      <h4>400px x 300px</h4>
    </div>
  )
}

export default TargetHeader
